import React from "react";
import { Mountain, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#314A3E] text-[#EAE5D9] mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <Mountain className="w-6 h-6" />
            <span className="font-bold text-xl" style={{ fontFamily: "Outfit" }}>Kootenay Home Pros</span>
          </div>
          <p className="text-sm leading-relaxed max-w-md text-[#EAE5D9]/80">
            Connecting Kootenay homeowners with vetted, local contractors. Built for the mountains, made for community.
          </p>
        </div>
        <div>
          <div className="overline mb-3 text-[#B85C47]">Contact</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5" /> Invermere, BC</li>
            <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5" /> hello@kootenayhomepros.ca</li>
            <li><a href="/terms" className="hover:text-white">Contractor Terms</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#EAE5D9]/60">
        © {new Date().getFullYear()} Kootenay Home Pros. All rights reserved.
      </div>
    </footer>
  );
}
